<template>
  <div class="cell-container">
    <ul class="cell-list scroll cell-editorpick">
      <li v-for="(cell, index) in cellList" :key="'editorPickCell_' + index">
        <a @click.prevent="goDetail(cell)" href="#">
          <div class="cell-img-editorpick">
            <img v-lazy="thumbnail(cell)" :alt="altTitle(cell)" aria-hidden="true">
          </div>
          <div class="cell-info">
            <div class="cell-title-wrap" v-title-list="{'titleList': cellTitle(cell)}"></div>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { get } from 'lodash'
import { titleList } from '@/common/directives'
import { selectCell, getTitle } from '@/common/util/common'
import { resizeThumbnail } from '@/common/image.filter'

export default {
  name: 'CellListEditorPick',
  props: {
    cellList: {
      type: Array
    },
    thumbnailInfo: {
      type: Object
    }
  },
  directives: {
    titleList
  },
  methods: {
    thumbnail (cell) {
      return resizeThumbnail(get(cell, 'thumbnail', ''), { width: 160, height: 160, quality: 75, multiply: 3, blur: 1 })
    },
    cellTitle (cell) {
      return get(cell, 'title_list', [])
    },
    goDetail (cell) {
      if (get(cell, 'event_list', []).length === 0) return
      selectCell(cell)
    },
    altTitle (cell) {
      return getTitle(cell)
    }
  }
}
</script>
